import CheckIn from "./pages/CheckIn";
import CheckInCompleted from "./pages/CheckInCompleted";
import GuestArea from "./pages/GuestArea";
import GuestAreaLogin from "./pages/GuestAreaLogin";
import GuestAreaRegister from "./pages/GuestAreaRegister";
import GuestAreaVerify from "./pages/GuestAreaVerify";
import HotelInfo from "./pages/HotelInfo";
import Login from "./pages/Login";
import PointOfInterest from "./pages/PointOfInterest";
import PointOfInterestDetail from "./pages/PointOfInterestDetail";
import PreventiveDetail from "./pages/PreventiveDetail";
import ServiceDetail from "./pages/ServiceDetail";
import Services from "./pages/Services";
import StructureLogin from "./pages/StructureLogin";
import SurveyPage from "./pages/Survey";
import Welcome from "./pages/Welcome";

interface AppRoute {
  path: string;
  title?: string;
  element: React.ReactNode;
}

export const routes: AppRoute[] = [
  {
    path: "/",
    element: <Welcome />,
  },
  {
    path: "/login/:token",
    element: <Login />,
  },
  {
    path: "/check-in",
    element: <CheckIn />,
  },
  {
    path: "/completed",
    element: <CheckInCompleted />,
  },
  {
    path: "/guest-area",
    element: <GuestArea />,
  },
  {
    path: "/guest-area/login",
    element: <GuestAreaLogin />,
  },
  {
    path: "/guest-area/register",
    element: <GuestAreaRegister />,
  },
  {
    path: "/guest-area/verify",
    element: <GuestAreaVerify />,
  },
  {
    path: "/hotel-info",
    element: <HotelInfo />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:id",
    element: <ServiceDetail />,
  },
  {
    path: "/point-of-interest",
    element: <PointOfInterest />,
  },
  {
    path: "/point-of-interest/:id",
    element: <PointOfInterestDetail />,
  },
  {
    path: "/structure/:id",
    element: <StructureLogin />,
  },
  {
    path: "/survey/:accessToken",
    element: <SurveyPage />,
  },
  {
    path: "/preventive-detail/:token",
    element: <PreventiveDetail />,
  },
];
